import { AlbumType, AlbumTypeDto } from '../model/types/albumSchema';

export const mapAlbumTypeFromDto = ({ id, name }: AlbumTypeDto): AlbumType => ({
  value: id.toString(),
  label: name,
});
